import styled from '@emotion/styled';
import { Button, Col, Menu, Row } from 'antd';
import FinportLogo from 'images/finport-logo-black.png';

export const HeaderContainer = styled(Row)`
  margin-bottom: ${props => props.theme.spacing.regular};
`;

export const AvatarButton = styled(Button)`
  background-color: ${props => props.theme.color.secondary};
  border-radius: 50%;
  box-shadow: 0px 3px 8px ${props => props.theme.color.primary}33;
  color: ${props => props.theme.color.primary};
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeight.bold};
  padding: 1px 7px 2px;
  height: 48px;
  width: 48px;
`;

export const MenuItem = styled(Menu.Item)`
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.regular};
`;

export const AccountInfoMenuItem = styled(MenuItem)`
  &:hover {
    background-color: ${props => props.theme.color.white};
    cursor: default;
  }
`;

export const CompanyLogoCol = styled(Col)`
  width: 72px;
  height: 72px;
  background-image: ${props => `url(${props.companyLogo || FinportLogo})`};
  border-radius: 50%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const NameText = styled.span`
  font-weight: bold;
  font-size: 16px;
`;

export const CompanyText = styled.span`
  font-weight: normal;
  color: ${props => props.theme.color.grey};
  font-size: 12px;
  display: block;
  white-space: pre-line;
`;
